export class ProcessingActivityRiskDTO {
    processingActivityId: number;
    
    riskId: number;
    
    constructor(processingActivityId?: number, riskId?: number) {
        this.processingActivityId = processingActivityId ?? -1;
        this.riskId = riskId ?? -1;
    }
}